import { useSelector } from 'react-redux'
import { track as amplitudeTrack } from '@amplitude/analytics-browser'
import { userAccountIdSelector } from 'auth/selectors'
import {
    ANALYTICS_FLOW_TYPE_BOOK_ADVANCE,
    ANALYTICS_FLOW_TYPE_PARK_NOW,
    ANALYTICS_FLOW_TYPE_EVENT,
    ANALYTICS_FLOW_TYPE_SUBSCRIPTION,
} from 'analytics/constants'
import { SEARCH_MODE_EVENTS, SEARCH_MODE_HOURLY, SEARCH_MODE_MONTHLY } from 'search/constants'
import { SHOW_HOURLY_FLOW_BOOK_IN_ADVANCE } from 'booking/constants'

export const getRwgToken = () => {
    const queryParams = new URLSearchParams(window.location.search)
    return queryParams.get('rwg_token')
}

const removeRwgTokenParam = () => {
    const url = new URL(window.location)
    const params = new URLSearchParams(url.search)

    params.forEach((value, key) => {
        if (key.includes('rwg_token')) {
            params.delete(key)
        }
    })

    url.search = params.toString()
    window.history.replaceState({}, document.title, url.toString())
}

export const setGoogleReserveCookiesFromUrl = locationId => {
    const tokenCookie = `_rwg_token=${getRwgToken()}; max-age=2592000; domain=${window.location.hostname}; path=/`
    const merchantIdCookie = `_merchant_id=${locationId}; max-age=2592000; domain=${window.location.hostname}; path=/`
    document.cookie = tokenCookie
    document.cookie = merchantIdCookie

    removeRwgTokenParam()
}

export const setAmplitudeInitialized = value => {
    if (typeof window === 'undefined') return
    window.amplitudeInitialized = value
}
export const isAmplitudeInitialized = () => typeof window !== 'undefined' && Boolean(window.amplitudeInitialized)

export const sendGTAGEvent = (eventName, params, userId) => {
    if (window?.gtag) {
        params.user_logged_in = Boolean(userId)
        window.gtag('event', eventName, params)
    }
}

export const sendAmplitudeEvent = (eventName, params = {}) => {
    try {
        if (isAmplitudeInitialized()) {
            amplitudeTrack(eventName, params)
        }
    } catch (error) {
        // do nothing, we don't want to break the app if amplitude tracking fails'
    }
}

export const useSendGTAGEvent = () => {
    const userAccountId = useSelector(userAccountIdSelector)

    return (eventName, params, userId = userAccountId) => {
        sendGTAGEvent(eventName, params, userId)
    }
}
export const getAnalyticsFlowType = (parkingMode, currentCustomerFlowType) => {
    if (parkingMode === SEARCH_MODE_HOURLY) {
        if (currentCustomerFlowType === SHOW_HOURLY_FLOW_BOOK_IN_ADVANCE) return ANALYTICS_FLOW_TYPE_BOOK_ADVANCE
        else return ANALYTICS_FLOW_TYPE_PARK_NOW
    } else if (parkingMode === SEARCH_MODE_EVENTS) return ANALYTICS_FLOW_TYPE_EVENT
    else if (parkingMode === SEARCH_MODE_MONTHLY) return ANALYTICS_FLOW_TYPE_SUBSCRIPTION
    else return ''
}
